import { mdiSortAscending, mdiSortDescending } from '@mdi/js';
import { useTranslation } from 'react-i18next';
import { IconButtonProps } from '@mui/material/IconButton';

import { ISortDirection, Maybe } from 'graphql/types';
import { IconButton } from 'common/components/IconButton';

interface IProps<T extends string = string> extends Omit<
    IconButtonProps,
    'ref'
> {
    currentSortField?: string;
    currentSortDirection?: Maybe<ISortDirection>;
    sortField: T;
}

export const TableSortButton = <T extends string = string>({
    currentSortField,
    currentSortDirection,
    sortField,
    ...other
}: IProps<T>) => {
    const [translate] = useTranslation();
    const color = currentSortField === sortField ? 'primary' : undefined;

    const isAscending =
        currentSortDirection === ISortDirection.Asc ||
        currentSortDirection === ISortDirection.AscNullsFirst;

    const icon =
        currentSortField === sortField && isAscending
            ? mdiSortAscending
            : mdiSortDescending;

    return (
        <IconButton
            aria-label={translate(`sort.${isAscending ? 'asc' : 'desc'}`)}
            color={color}
            iconPath={icon}
            iconSize="1.6rem"
            sx={{ ml: 0.2 }}
            {...other}
        />
    );
};
